import { FacsimileViewer, FullPageViewer } from "../../facsimileViewer/dist";

// TODO
document.querySelectorAll('a.anchor')
  .forEach(a => a.setAttribute('href', '#' + a.getAttribute('name')))


const facsimileElement = document.getElementById('facsimile');
const facsimileViewer = new FacsimileViewer(facsimileElement, 'div.paragraph', {});

const viewerElement =document.getElementById('facsimileViewer');
const fullPageViewer = new FullPageViewer(viewerElement, { });

facsimileViewer.setViewer(fullPageViewer);

const closeViewer = _ev => location.assign(location.href.replace(/\/text-image#.*$/, ''));
const zoomIn = _ev => fullPageViewer.zoomIn();
const zoomOut = _ev => fullPageViewer.zoomOut();
const nextImage = _ev => {
  const image = fullPageViewer.nextImage();
  window.location.hash = '#' + image['id'];
};
const previousImage = _ev => {
  const image = fullPageViewer.previousImage();
  window.location.hash = '#' + image['id'];
}

function toggleFullScreen() {
  if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen();
  } else {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    }
  }
}

const fullscreen = _ev => toggleFullScreen();

const viewerControlElement = document.getElementById('facsimileViewerControl');
viewerControlElement.querySelector('.closeViewerBtn ').addEventListener('click', closeViewer);
viewerControlElement.querySelector('.zoomInBtn').addEventListener('click', zoomIn);
viewerControlElement.querySelector('.zoomOutBtn').addEventListener('click', zoomOut);
viewerControlElement.querySelector('.nextImageBtn').addEventListener('click', nextImage);
viewerControlElement.querySelector('.previousImageBtn').addEventListener('click', previousImage);

viewerControlElement.querySelector('.fullscreenBtn').addEventListener('click', fullscreen);

document.querySelector('body').addEventListener('click', event => {
  const el = <HTMLElement> event.target;
  if (el.classList.contains('pbImg')) {
    const ref = el.getAttribute('data-ref').substring(1);
    fullPageViewer.setImage(ref);
    viewerElement.classList.add('fv-active');
    window.location.hash = ref;
  }
});

// load image if defined after #

const loadImageFromHash = () => {
  const ref = window.location.hash;
  if (ref) {
    fullPageViewer.setImage(ref.substring(1));
    viewerElement.classList.add('fv-active');
  }
}

loadImageFromHash();

// on location change
window.addEventListener('hashchange', loadImageFromHash, false);